import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

/**
 * Generic wizard step wrapper with stepper progress.
 */
const WizardStep = ({ step, totalSteps, title, children }) => (
  <Box>
    {/* Step indicator */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
      <Typography sx={{ fontSize: 13, color: '#5F6B7A', fontWeight: 600 }}>
        {step}/{totalSteps}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={(step / totalSteps) * 100}
        sx={{
          flex: 1, height: 6, borderRadius: 3,
          bgcolor: '#EEF0F3',
          '& .MuiLinearProgress-bar': { bgcolor: '#1E3A5F', borderRadius: 3 },
        }}
      />
    </Box>

    {/* Title */}
    <Typography
      variant="h6"
      sx={{ fontWeight: 700, color: '#1A1A1A', mb: 3, fontSize: { xs: '1.1rem', md: '1.25rem' } }}
    >
      {title}
    </Typography>

    {children}
  </Box>
);

export default WizardStep;
